import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomRescuersTableLayer from "../components/CustomRescuersTableLayer";

const CustomRescuersTable = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
       
        <Breadcrumb title="Rescuers List" tooltipContent="New Rescuers Data" linkTo="/rescures/add" requiredPermission={{ module: 'rescuers', action: 'create' }} />
        
        {/* TableDataLayer */}
        <CustomRescuersTableLayer  />

      </MasterLayout>

    </>
  );
};

export default CustomRescuersTable; 
